export default __webpack_public_path__ + "static/TDF_logo-64a1589a4294f62732cd0ab7a339bcbb.png";